export const extractAttachmentFileName = (url: string): string | null => {
  try {
    const parsedUrl = new URL(url);
    const match = parsedUrl.pathname.match(/[^/]+$/);

    return match ? decodeURIComponent(match[0]) : null;
  } catch (error) {
    return "Attachment";
  }
};

export async function blobToArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
  const response = new Response(blob);
  return response.arrayBuffer();
}

export const getExtensionFromMimeType = (blob: Blob): string => {
  const mimeToExtension: Record<string, string> = {
    // Documents
    "application/pdf": "pdf",
    "text/plain": "txt",
    "application/rtf": "rtf",
    "text/rtf": "rtf",

    // Microsoft Word
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      "docx",

    // Microsoft Excel
    "application/vnd.ms-excel": "xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "application/vnd.ms-excel.sheet.macroEnabled.12": "xlsm",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.12": "xlsb",

    // Microsoft PowerPoint
    "application/vnd.ms-powerpoint": "ppt",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      "pptx",
    "application/vnd.ms-powerpoint.presentation.macroEnabled.12": "pptm",

    // CSV and Data
    "text/csv": "csv",
    "application/csv": "csv",
    "text/comma-separated-values": "csv",

    // Images
    "image/jpeg": "jpg",
    "image/jpg": "jpg",
    "image/png": "png",
    "image/gif": "gif",
    "image/bmp": "bmp",
    "image/webp": "webp",
    "image/svg+xml": "svg",
    "image/tiff": "tiff",
    "image/x-icon": "ico",
    "image/vnd.microsoft.icon": "ico",

    // Archives
    "application/zip": "zip",
    "application/x-zip-compressed": "zip",
    "application/x-rar-compressed": "rar",
    "application/x-rar": "rar",
    "application/x-7z-compressed": "7z",
    "application/x-tar": "tar",
    "application/gzip": "gz",
    "application/x-gzip": "gz",

    // Audio
    "audio/mpeg": "mp3",
    "audio/mp3": "mp3",
    "audio/wav": "wav",
    "audio/wave": "wav",
    "audio/x-wav": "wav",
    "audio/ogg": "ogg",
    "audio/aac": "aac",
    "audio/x-m4a": "m4a",

    // Video
    "video/mp4": "mp4",
    "video/mpeg": "mpeg",
    "video/quicktime": "mov",
    "video/x-msvideo": "avi",
    "video/x-ms-wmv": "wmv",
    "video/webm": "webm",

    // Web
    "text/html": "html",
    "text/css": "css",
    "application/json": "json",
    "application/xml": "xml",
    "text/xml": "xml"
  };

  return mimeToExtension[blob.type] || "";
};
